import { render, staticRenderFns } from "./plot_text.vue?vue&type=template&id=1ba50021&scoped=true&"
import script from "./plot_text.vue?vue&type=script&lang=js&"
export * from "./plot_text.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba50021",
  null
  
)

export default component.exports